var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EnergyPredictionComponent"},[_c('energyPrediction',{attrs:{"searchBoxCond":_vm.searchBoxCondType2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }